import { BaseOwnerEntity } from "../../entity/baseOwnerEntity";

export class OrderItemDetailEntity extends BaseOwnerEntity {
  id?: number;
  orderItemId?: number;
  orderItemTypeId?: number;
  priceScreen?: number;
  priceOrginal?: number;
  priceChangeNotes?: string;
  isAvailableDiscount?: boolean;
  status?: number;
  dispatchDate?: Date;
  dispatchStatusId?: number;
  isAvailableForDispatch?: boolean;
  preparedDate?: Date;
  preparedUser?: number;
  supplierId?: number;
  dispatchStartDate?: Date;
  currencyCode?: string;
  totalDiscountAmount?: number;
  finalAmount?: number;
  totalAmount?: number;
}